module.exports = __webpack_public_path__ + "assets/img/imte2.4b18d48e.png";